<template>
    <span style="max-width: 25rem;">
        <a :href="url" target="_blank" style="color: #ff7516;">
            <i class="fas fa-external-link-alt mr-2"></i>{{ short_text }}
        </a>
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <i
                    v-bind="attrs"
                    v-on="on"
                    class="far fa-clipboard ml-1 cursor-pointer"
                    :class="icon_color"
                    @click="copyContentToClipboard(url)"
                    @mouseover="hoverEffect()"
                    @mouseleave="hoverEffectEnd()"
                ></i>
            </template>
            <span>Copy URL</span>
        </v-tooltip>
    </span>
</template>

<script>

export default {
    name: "ShortExternalUrl",
    props: [
        'url',
        'text'
    ],
    data: () => ({
        icon_color: 'text-dark'
    }),
    created() {
        //
    },
    methods: {
        copyContentToClipboard(url) {
            navigator.clipboard.writeText(url);
            this.icon_color = 'text-success'
        },
        hoverEffect() {
            this.icon_color = 'text-info'
        },
        hoverEffectEnd() {
            this.icon_color = 'text-dark'
        },
    },
    computed: {
        short_text() {
            let modified_text = this.text

            if (this.text) {
                let end  = this.text.slice(-40)

                modified_text = '...' + end
            }

            return modified_text
        }
    },
    mounted() {
        //
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>